// Customizable Area Start
import React, { useEffect } from "react";
import { StyleSheet, Text, View, TouchableOpacity } from "react-native";
import GlobalCss from "../../../framework/src/GlobalCss";
import DesktopDesign from "../../../components/src/componentDashboard/DesktopMaterialDetails";
import { ROLE_ID } from "../../../../packages/framework/src/Utilities";
import * as IMG_CONST from '../../../blocks/dashboard/src/assets'
import { getColorWithAlpha, getDescriptionText } from "../../../../packages/framework/src/CustomPopUp";
import { getColorCode } from "../RygCircle";

export default function MaterialDetails({ navigation }: { navigation: any }) {
  const dummyDescription = "No description available";
  const material = JSON.parse(localStorage.getItem("selectedMaterial") || "{}");
  const role_id = localStorage.getItem("role") || "";

  const navigateToEdit = () => {
    localStorage.setItem("editMaterialData", JSON.stringify(material));
    navigation.navigate("NewMaterial");
  };

  useEffect(() => {
    localStorage.removeItem("editMaterialData");
  }, []);

  return window.screen.width < 950 ? (
    <View style={styles.container}>
      <View style={styles.headingView}>
        <TouchableOpacity
          style={styles.leftArrowIconWrapper}
          onPress={() => navigation.goBack()}
          testID='navigateDashboard'
        >
          <img
            src={IMG_CONST.leftArrow1}
            style={{
              height: 24,
              width: 24,
            }}
          />
        </TouchableOpacity>
        <Text numberOfLines={2} style={styles.heading}>
          {material.attributes.name}
        </Text>
      </View>
      <View
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
        }}
      >
        <View>
          <View style={{ marginHorizontal: "auto" }}>
            <img
              src={
                material.attributes.image
                  ? material.attributes.image
                  : IMG_CONST.dummyMaterial
              }
              style={{
                height: 274,
                width: 274,
                borderRadius: 12,
                paddingTop: 10,
              }}
            />
            <View style={styles.line} />
          </View>
          <View
            style={{
              marginHorizontal: 24,
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <Text style={{ fontSize: 24, color: "#4e3e71" }}>
              {material.attributes.name}{" "}
            </Text>
            <Text style={{ fontSize: 24, color: "#4e3e71" }}>
              (Manufacturor test :{" "}
              {material.attributes.brand.data.attributes.name})
            </Text>
            <View style={[
              styles.rygStatus,
              { backgroundColor: getColorWithAlpha(material.attributes.color_value, 0.15) }
            ]}>
              <View style={[styles.rvgCircle, { backgroundColor: getColorCode(material.attributes.color_value) }]}></View>
              <Text>{getDescriptionText(material.attributes.color_value)}</Text>
            </View>
            <Text
              style={{ fontSize: 16, paddingVertical: 10, color: "#4e3e71" }}
            >
              {material.attributes.description
                ? material.attributes.description
                : dummyDescription}
            </Text>
          </View>
        </View>
        {role_id === ROLE_ID.SALES && (
          <View>
            <TouchableOpacity
              onPress={() => navigateToEdit()}
              style={GlobalCss.buttonView}
            >
              <Text style={GlobalCss.buttonText}>Edit Details</Text>
            </TouchableOpacity>
          </View>
        )}
      </View>
    </View>
  ) : (
    <DesktopDesign navigation={navigation} />
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: "#fff",
    flexDirection: "column",
  },
  editBTn: {
    fontSize: 18,
    fontWeight: "700",
    color: "#4e3e71",
    textDecorationLine: "underline",
  },
  line: {
    width: 48,
    height: 5,
    borderRadius: 100,
    backgroundColor: "#e5e5e5",
    marginHorizontal: "auto",
    marginVertical: 50,
  },
  leftArrowIconWrapper: {
    width: 24,
    height: 24,
    position: "absolute",
    left: 24,
  },
  rvgCircle: {
    height: 16,
    width: 16,
    borderRadius: 8,
    marginRight: 10
  },
  btn: {
    fontSize: 30,
    color: "#4e3e71",
    paddingVertical: 2,
    paddingHorizontal: 10,
  },
  rygStatus: {
    alignSelf: 'flex-start',
    borderRadius: 20,
    padding: 10,
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 25,
    marginBottom: 25
  },
  headingView: {
    flexDirection: "row",
    alignItems: "center",
    paddingVertical: 27,
    backgroundColor: "#4e3e71",
    marginBottom: 20,
  },
  heading: {
    color: "#e8fafe",
    fontSize: 18,
    marginHorizontal: 40,
    paddingHorizontal: 30,
  },
  color: {
    color: "#0579ed",
    fontSize: 20,
  },
  button: {
    borderRadius: 12,
    paddingVertical: 15,
    paddingHorizontal: 50,
    marginHorizontal: 20,
    backgroundColor: "#4e3e71",
    marginBottom: 10,
    marginTop: 10,
  },
  buttonText: {
    color: "#e8fafe",
    fontSize: 17,
    textAlign: "center",
  },
});
// Customizable Area End
